// Notification.jsx
import React, { useEffect, useState } from 'react';
import '../assets/css/Notification.css';

const Notification = ({ title, description, time }) => {
    const [visible, setVisible] = useState(true);
    const [progress, setProgress] = useState(100);

    useEffect(() => {
        const interval = time / 100;
        const timer = setTimeout(() => setVisible(false), time || 5000);
        const progressInterval = setInterval(() => {
            setProgress((prev) => Math.max(prev - 1, 0));
        }, interval);

        return () => {
            clearTimeout(timer);
            clearInterval(progressInterval);
        };
    }, [time]);

    const handleClick = () => {
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="notification" onClick={handleClick}>
            <h3 className="notification-title">{title}</h3>
            <p className="notification-description" dangerouslySetInnerHTML={{ __html: description }}></p>
            <div className="notification-progress" style={{ width: `${progress}%` }}></div>
        </div>
    );
};

export default Notification;